import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	systemGroupOld: {
		id: 'spa-apps-sidebar-global-settings-system.menu.system-group-old',
		defaultMessage: 'System',
		description: 'Navigation group heading for system settings items',
	},
	systemGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.system-group',
		defaultMessage: 'System settings',
		description: 'Navigation group heading for system settings items',
	},
	generalConfiguration: {
		id: 'spa-apps-sidebar-global-settings-system.menu.general-configuration',
		defaultMessage: 'General configuration',
		description: 'Navigation item which links to a general configuration settings page',
	},
	darkFeatures: {
		id: 'spa-apps-sidebar-global-settings-system.menu.dark-features',
		defaultMessage: 'Dark features',
		description: 'Navigation item which links to a dark features settings page',
	},
	issueCollectors: {
		id: 'spa-apps-sidebar-global-settings-system.menu.issue-collectors',
		defaultMessage: 'Issue collectors',
		description: 'Navigation item which links to an issue collectors settings page',
	},
	globalSettingsSystemSidebarLabel: {
		id: 'spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label',
		defaultMessage: 'Sidebar',
		description: 'Global issues setting sidebar label',
	},
	issueCollectorsIssueTermRefresh: {
		id: 'spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh',
		defaultMessage: 'Work item collectors',
		description: 'Navigation item which links to an issue collectors settings page',
	},
});
